"use strict";

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.trim = function (str, _char) {
  return str.replace(new RegExp("^[" + _char + "]+|[" + _char + "]+$", "g"), "");
};